// extracted by mini-css-extract-plugin
export var carrierNotice = "_ky-5";
export var carrierNoticePlaceholder = "_ky-6";
export var deliveryRow = "_ky-c";
export var fixedHeight = "_ky-4";
export var freightLogo = "_ky-b";
export var fullWidth = "_ky-3";
export var priceColumn = "_ky-7";
export var radioSelected = "_ky-9";
export var radioUnselected = "_ky-8";
export var selectedOption = "_ky-2";
export var selectedOptionContainer = "_ky-1";
export var selection = "_ky-0";
export var tallSkeletonText = "_ky-a";